<template>
  <transition name="slide-fade">
    <div :class="{ design_mode: design }" v-if="field_visible && can_show">
      <div class="mt-3">
        <b-card :title="field_label" body-class="text-center">
          <b-card-text>
            {{ wizardDescription }}
          </b-card-text>

          <b-button v-if="showWizardStart" @click="onStartClick">
            {{ startButton }}
          </b-button>
        </b-card>
      </div>

      <!-- Layout 1 -->
      <!-- <b-container class="mb-2" style="background-color: #fff; min-height: 60px; border-radius: 8px; display: flex; align-items: center; justify-content: space-around;" >
        <div v-for="field in field.fields" :key="field.id" style="background-color: #D5D5D5; min-height: 10px; padding: 8px 10px; border-radius: 8px; border: 1.5px solid #4180E7;">
          <span>{{field.display_order}}.</span>
          <span style="color: #434343"> {{field_label}} </span>
        </div>
      </b-container> -->

      <!-- Layout 2 -->
      <b-container v-if="!showWizardStart || design">
        <div class="stepper stepper--alt-labels sheet">
          <div class="stepper__header">
            <template v-for="(field, index) in field.fields">
              <div
                :key="field.id"
                tabindex="-1"
                class="stepper__step stepper__step--active"
              >
                <span
                  :style="activeStepStyle(index)"
                  class="stepper__step__step"
                  >{{ field.display_order }}</span
                >
                <div class="stepper__label">{{ field_label }}</div>
              </div>
              <hr
                v-if="showSeparator(index)"
                :key="field.id"
                :style="activeStepDividerStyle(index)"
                role="separator"
                aria-orientation="horizontal"
                class="divider"
              />
            </template>
          </div>
        </div>
      </b-container>

      <f-widget-list
        :design="design"
        :disabled="is_disabled"
        :fields="field.fields"
        :form-state="formState"
        :form-context="nestedFormContext"
        :item="the_item[field.code]"
        :selector="selector"
        @change="change"
        @error="handleError"
        @fields-change="fieldsChanged"
      ></f-widget-list>

      <div style="" class="row mt-3" v-if="showBackNext || design">
        <div :class="'col-sm-12 self-start ' + buttonsAlignment">
          <b-button :disabled="isBackDisabled" @click="prevButton">{{
            backButton
          }}</b-button>
          <b-button
            class="ml-2"
            :disabled="isNextDisabled"
            @click="forwardButton"
            >{{ nextButton }}</b-button
          >
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { setter } from "../setter";
import { prepareExpression } from "../../../vue-ocom/query/expression.js";
import FWidgetList from "../FWidgetList.vue";
import ContainerWidgetMixin from "../ContainerWidgetMixin.js";
import { evalExpression } from "@/vue-forms247/utils/expressions.js";
import OListActions from "../../../vue-ocom/components/table/OListActions.vue";
import OSection from "../../../vue-ocom/components/layout/OSection.vue";

import { FIELD_TYPES, FIELD_TYPES_BY_CODE } from "../../field_types.js";

export default {
  name: "WizardWidget",
  mixins: [ContainerWidgetMixin],

  components: { FWidgetList, OSection, OListActions },

  data() {
    return {
      currentStep: 0,
      showWizardStart: true,
      isNextDisabled: false,
      isBackDisabled: false,
      showBackNext: false,
    };
  },

  computed: {
    can_show() {
      if (this.design) {
        return true;
      }

      try {
        if (this.field.params.expression) {
          return evalExpression(this.field.params.expression, this.item);
        } else {
          return this.expression_function(this.item);
        }
      } catch (ex) {
        return false; // error..
      }
    },
    expression_function() {
      if (this.field.params.expression) {
        return compileExpression(this.field.params.expression, {
          extraFunctions: ExpressionFunctions,
        });
      } else {
        return prepareExpression([
          this.field.params.field,
          this.field.params.comparison,
          this.field.params.match_value,
        ]).evaluate;
      }
    },

    wizardDescription: function () {
      return this.field.params.wizard_description || "Wizard description";
    },

    startButton: function () {
      return this.field.params.start_button || "Start";
    },

    backButton: function () {
      return this.field.params.back_button || "Back";
    },

    nextButton: function () {
      return this.field.params.next_button || "Next";
    },

    buttonsAlignment: function () {
      return this.field.params.buttons_alignment || "";
    },
  },
  methods: {
    on_input: function (value) {
      if (!this.is_disabled) {
        var item = this.item || {};

        setter(this, item[this.field.code], "__visible", this.can_show); // store if visible

        this.change(item);
      }
    },

    showSeparator(index) {
      if (index !== this.field.fields.length - 1) {
        return true;
      }
      return false;
    },

    activeStepStyle(index) {
      if (this.currentStep === index || this.currentStep > index) {
        return {
          color: "#fff",
          "background-color": this.field.params.steps_color || "red",
          border: "2px solid " + this.field.params.steps_color || "red",
        };
      }

      return { border: "2px solid " + this.field.params.steps_color || "red" };
    },

    activeStepDividerStyle(index) {
      if (this.currentStep === index || this.currentStep > index) {
        return {
          border: "2px solid " + this.field.params.steps_color || "red",
        };
      }
    },

    onStartClick() {
      this.resetSteps();

      if (this.design) {
        this.showWizardStart = true;
        return;
      }

      this.showWizardStart = false;
      this.field.fields[0].visible = true;
      console.log(`[${new Date().toISOString()}] WizardWidget @change event:`, {
        component: "WizardWidget",
        method: "onStartClick",
        fieldCode: this.field.code,
        field: this.field,
      });
      this.$emit("change", this.field);
      this.isNextDisabled = false;
      this.isBackDisabled = false;
      this.showBackNext = true;
    },

    prevButton() {
      if (this.currentStep !== 0) {
        this.currentStep--;
        this.showHideSteps(this.currentStep);
        return;
      }

      this.showWizardStart = true;
      this.showBackNext = false;
      this.field.fields[0].visible = false;
      console.log(`[${new Date().toISOString()}] WizardWidget @change event:`, {
        component: "WizardWidget",
        method: "prevButton",
        fieldCode: this.field.code,
        field: this.field,
      });
      this.$emit("change", this.field);
    },

    forwardButton() {
      if (this.currentStep !== 1) {
        this.isBackDisabled = false;
      }

      if (this.field.fields.length - 1 > this.currentStep) {
        this.currentStep++;
        this.showHideSteps(this.currentStep);
      }
    },

    showHideSteps(index) {
      this.field.fields.map((field, fieldIndex) => {
        if (fieldIndex === index) {
          field.visible = true;
        } else {
          field.visible = false;
        }

        return field;
      });

      console.log(`[${new Date().toISOString()}] WizardWidget @change event:`, {
        component: "WizardWidget",
        method: "showHideSteps",
        fieldCode: this.field.code,
        stepIndex: index,
        field: this.field,
      });
      this.$emit("change", this.field);
    },

    resetSteps() {
      this.field.fields.map((field) => {
        field.visible = false;
        return field;
      });
      console.log(`[${new Date().toISOString()}] WizardWidget @change event:`, {
        component: "WizardWidget",
        method: "resetSteps",
        fieldCode: this.field.code,
        field: this.field,
      });
      this.$emit("change", this.field);
    },
  },
  watch: {
    can_show: function (value) {
      this.on_input(value); // store the value.
      console.info("xx");
    },
  },
  created: function () {
    this.resetSteps();
    if (this.item && !(this.field.code in this.item)) {
      this.setter(this, this.item, this.field.code, {});
    }
  },
};
</script>

<style>
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>

<style scoped>
.design_mode {
  border: #b1b1b1 4px dotted;
  min-height: 100px;
}

.stepper {
  overflow: hidden;
  position: relative;
}

.stepper--alt-labels .stepper__header {
  height: auto;
}

.stepper__header {
  height: 72px;
  align-items: stretch;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.stepper--alt-labels .stepper__step {
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex-basis: 175px;
}

.stepper__step {
  align-items: center;
  display: flex;
  flex-direction: row;
  padding: 24px 20px;
  position: relative;
}

.stepper--alt-labels .stepper__step__step {
  margin-bottom: 11px;
  margin-left: 0;
  margin-right: 0;
}

.stepper__step__step {
  align-items: center;
  border-radius: 50%;
  display: inline-flex;
  font-size: 1rem;
  font-weight: 700;
  justify-content: center;
  height: 40px;
  min-width: 40px;
  width: 40px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  /* background-color: red; */
  color: rgb(117, 116, 116);
  border: 2px solid red;
}

.stepper--alt-labels .stepper__header .divider {
  margin: 40px -67px 0;
  align-self: flex-start;
}

.divider {
  display: block;
  flex: 1 1 0px;
  max-width: 100%;
  height: 0;
  max-height: 0;
  border: 2px solid rgb(158, 157, 157);
  transition: inherit;
}

hr {
  overflow: visible;
  height: 0;
}

@media screen and (max-width: 576px) {
  .stepper__step {
    padding: 24px 0px;
  }

  .stepper__step__step {
    font-size: 0.75rem;
    height: 30px;
    min-width: 30px;
    width: 30px;
  }

  .stepper__label {
    display: none;
  }

  .stepper--alt-labels .stepper__header .divider {
    margin: 38px -98px 0;
  }
}
</style>
